import * as rules from 'vee-validate/dist/rules'
import { extend, localize, ValidationProvider, ValidationObserver, setInteractionMode } from 'vee-validate'
import zhCN from 'vee-validate/dist/locale/zh_CN.json'
import Vue from 'vue'
import InputWithValidation from '@/components/InputWithValidation'
import SelectWithValidation from '@/components/SelectWithValidation'
import RadioWithValidation from '@/components/RadioWithValidation'

// set the global default mode
setInteractionMode('lazy')

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

localize('zh_CN', zhCN)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('InputWithValidation', InputWithValidation)
Vue.component('SelectWithValidation', SelectWithValidation)
Vue.component('RadioWithValidation', RadioWithValidation)
